// extracted by mini-css-extract-plugin
module.exports = {"black":"#23272A","dark":"#2C2F33","greyple":"#99AAB5","white":"#FFFFFF","notsowhite":"rgba(255,255,255,0.4)","blurple":"#7289DA","blurple-hover":"#697ec4"};